const selectSurface = 'var(--color-surface-panel)'
const selectMutedSurface = 'var(--color-surface-tertiary)'
const selectHoverSurface = 'var(--color-surface-hover)'
const selectBorder = 'var(--color-border-default)'
const selectBorderHover = 'var(--color-border-hover)'
const selectAccent = 'var(--color-accent-light-purple)'
const selectText = 'var(--color-text-primary)'
const selectMutedText = 'var(--color-text-secondary)'
const selectPlaceholder = 'var(--color-text-placeholder)'
const selectInverseText = 'var(--color-text-inverse)'
const selectInviteBlue = 'var(--color-text-link)'
const selectInviteBlueSurface =
    'color-mix(in srgb, var(--color-text-link) 16%, var(--color-surface-panel))'
const selectInviteBlueBorder = 'color-mix(in srgb, var(--color-text-link) 55%, transparent)'

export const themedCreatableSelectStyles = {
    container: base => ({
        ...base,
        width: '100%',
    }),
    control: (base, state) => ({
        ...base,
        backgroundColor: selectSurface,
        borderColor: state.isFocused ? selectAccent : selectBorder,
        boxShadow: state.isFocused ? `0 0 0 1px ${selectAccent}` : 'none',
        minHeight: 46,
        transition: 'border-color 0.2s ease, box-shadow 0.2s ease',
        ':hover': {
            ...base[':hover'],
            borderColor: state.isFocused ? selectAccent : selectBorderHover,
        },
    }),
    input: base => ({
        ...base,
        color: selectText,
    }),
    placeholder: base => ({
        ...base,
        color: selectPlaceholder,
    }),
    singleValue: base => ({
        ...base,
        color: selectText,
    }),
    menu: base => ({
        ...base,
        backgroundColor: selectSurface,
        border: `1px solid ${selectBorder}`,
        boxShadow: '0 10px 30px rgba(0, 0, 0, 0.2)',
        overflow: 'hidden',
        zIndex: 20,
    }),
    menuList: base => ({
        ...base,
        paddingTop: 4,
        paddingBottom: 4,
    }),
    option: (base, state) => ({
        ...base,
        backgroundColor: state.isSelected
            ? selectAccent
            : state.isFocused
            ? selectHoverSurface
            : selectSurface,
        color: state.isSelected ? selectInverseText : selectText,
        cursor: 'pointer',
        ':active': {
            ...base[':active'],
            backgroundColor: state.isSelected ? selectAccent : selectHoverSurface,
        },
    }),
    multiValue: base => ({
        ...base,
        backgroundColor: selectMutedSurface,
    }),
    multiValueLabel: base => ({
        ...base,
        color: selectText,
    }),
    multiValueRemove: base => ({
        ...base,
        color: selectMutedText,
        ':hover': {
            ...base[':hover'],
            backgroundColor: selectHoverSurface,
            color: selectText,
        },
    }),
    indicatorSeparator: base => ({
        ...base,
        backgroundColor: selectBorder,
    }),
    dropdownIndicator: base => ({
        ...base,
        color: selectMutedText,
        ':hover': {
            ...base[':hover'],
            color: selectText,
        },
    }),
    clearIndicator: base => ({
        ...base,
        color: selectMutedText,
        ':hover': {
            ...base[':hover'],
            color: selectText,
        },
    }),
}

export const themedSettingsSelectStyles = {
    ...themedCreatableSelectStyles,
    control: (base, state) => ({
        ...base,
        alignItems: 'center',
        backgroundColor: state.isFocused ? selectHoverSurface : 'transparent',
        border: `1px solid ${state.isFocused ? selectAccent : selectBorder}`,
        borderRadius: 6,
        boxShadow: 'none',
        cursor: 'pointer',
        minHeight: 34,
        transition: 'background-color 0.2s ease, border-color 0.2s ease',
        ':hover': {
            ...base[':hover'],
            backgroundColor: selectHoverSurface,
            borderColor: state.isFocused ? selectAccent : selectBorderHover,
        },
    }),
    valueContainer: base => ({
        ...base,
        padding: '2px 0 2px 10px',
    }),
    singleValue: base => ({
        ...base,
        color: selectText,
        fontSize: 14,
        lineHeight: 1.2,
        marginLeft: 0,
        marginRight: 0,
    }),
    dropdownIndicator: base => ({
        ...themedCreatableSelectStyles.dropdownIndicator(base),
        color: selectMutedText,
        padding: '7px 8px',
    }),
    clearIndicator: base => ({
        ...themedCreatableSelectStyles.clearIndicator(base),
        padding: '7px 8px',
    }),
    indicatorSeparator: () => ({
        display: 'none',
    }),
    menu: base => ({
        ...base,
        backgroundColor: selectSurface,
        border: `1px solid ${selectBorder}`,
        borderRadius: 10,
        boxShadow: '0 6px 24px rgba(0, 0, 0, 0.12)',
        overflow: 'hidden',
        padding: 6,
        zIndex: 20,
    }),
    menuList: base => ({
        ...base,
        paddingTop: 0,
        paddingBottom: 0,
    }),
    option: (base, state) => ({
        ...base,
        alignItems: 'center',
        backgroundColor: state.isSelected
            ? selectHoverSurface
            : state.isFocused
            ? selectHoverSurface
            : 'transparent',
        borderRadius: 6,
        color: selectText,
        cursor: 'pointer',
        display: 'flex',
        fontSize: 14,
        lineHeight: 1.2,
        padding: '8px 10px',
        ':active': {
            ...base[':active'],
            backgroundColor: selectHoverSurface,
        },
    }),
    menuPortal: base => ({
        ...base,
        zIndex: 1701,
    }),
}

export const themedUserInviteSelectStyles = {
    ...themedCreatableSelectStyles,
    multiValue: base => ({
        ...base,
        backgroundColor: selectInviteBlueSurface,
        border: `1px solid ${selectInviteBlueBorder}`,
        borderRadius: 8,
        overflow: 'hidden',
    }),
    multiValueLabel: base => ({
        ...base,
        color: selectInviteBlue,
        fontWeight: 600,
        paddingLeft: 8,
        paddingRight: 6,
    }),
    multiValueRemove: base => ({
        ...base,
        color: selectInviteBlue,
        borderLeft: `1px solid ${selectInviteBlueBorder}`,
        ':hover': {
            ...base[':hover'],
            backgroundColor: selectInviteBlue,
            color: selectInverseText,
        },
    }),
}
